import React, { Component } from 'react';
import {  Button, Row, Col } from 'react-bootstrap';
import { translate } from "react-i18next";
import CommentPollResult from "./CommentPollResult";
import CommentAdd from './CommentAdd';
import {GREEN_LIGHT} from "../../backend/Colors";




function emptyComment() {
    return {
      comment:'',
      username:'',
      eventId:'',
      userId:'',
      email:'',
      id:0,
      creationDate: new Date()
    };
  }

class CommentPollAndResponse extends Component {

    constructor(props) {
        super(props);

        this.onResponseAdd = this.onResponseAdd.bind(this);
    
        this.state = {
            enableResponse: false
        };
    }

    onResponseAdd(){
        this.setState({
            enableResponse: true
        })
    }

    render() {
        const { t } = this.props;
        let commentId = this.props.comment.id;
        let parentId = this.props.comment.parentId ? this.props.comment.parentId : this.props.comment.id ;
        let invitedId = this.props.invitedUser.id;
        return <div className="mt-3">
            <Row >
                <Col >
                    <Button variant="link" className="float-left" onClick={() => this.props.onPoll(commentId, invitedId, 'YES')} ><span style={{"color":GREEN_LIGHT}} className=" fas fa-thumbs-up s24"></span></Button>
                    <CommentPollResult commentId={commentId} response="YES" count={this.props.yesCount}/>
                </Col>
                <Col >
                    <Button variant="link" className="float-left s24" onClick={() => this.onResponseAdd()} ><span   className="fas fa-reply s2 mr-2"></span>{t("response")}</Button>
                </Col>
            </Row>

            {this.state.enableResponse ?
                 <Row >
                     <Col>
                        <CommentAdd onAdd={this.props.onAdd} invitedUser={this.props.invitedUser} selected={this.state.selected} parentId={parentId}  />
                    </Col>
                 </Row>
                 :
                 ""
            }
         
        </div>
    }

}

export default translate("translations")(CommentPollAndResponse);